import { setSession, getSession, clearSessionKeys } from '../services/session';
import { clearUrlParamsWithoutRefreshPage } from '../services/util';

export const SOURCE_GA = 'ga-novacoop';
export const SOURCE_4BEE = '4bee';

const URL_PARAM_KEY_APDATA = 'APDATAPARAMS';
const URL_PARAM_KEY_4BEE = '4BEEPARAMS';

/**
 * Get employee credentials from 4bee or apdata
 * @returns {{sourceSystem: string, token: (string|string)}|undefined}
 */
export default function useEmployeeCredentials() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const searchParams = Object.fromEntries(urlSearchParams.entries());

  /**
   * Tratamento feito para evitar o bug de acesso na mesma máquina,
   * quando o sistema é acessado pelo apData e pelo 4bee com tokens diferentes.
   *
   * Neste caso, o sistema dava preferência pelo token do APDATA, mesmo quando o
   * acesso era feito utilizando o token do 4BEE.
   *
   * Foi uma solicitação da infra ocultar os parâmetros da URL para que os
   * usuários não compartilhem o link com o token.
   *
   * Então a solução foi salvar na sessão o token para os casos em que o usuário
   * atualiza a página e está sem o token na URL.
   */
  if (searchParams[URL_PARAM_KEY_APDATA]) {
    const token = searchParams[URL_PARAM_KEY_APDATA].valueOf();
    clearSessionKeys([URL_PARAM_KEY_4BEE]);
    setSession(URL_PARAM_KEY_APDATA, token);
    clearUrlParamsWithoutRefreshPage();
    return { sourceSystem: SOURCE_GA, token };
  }

  if (searchParams[URL_PARAM_KEY_4BEE]) {
    const token = searchParams[URL_PARAM_KEY_4BEE].valueOf();
    clearSessionKeys([URL_PARAM_KEY_APDATA]);
    setSession(URL_PARAM_KEY_4BEE, searchParams[URL_PARAM_KEY_4BEE].valueOf());
    clearUrlParamsWithoutRefreshPage();
    return { sourceSystem: SOURCE_4BEE, token };
  }

  const apDataToken = getSession(URL_PARAM_KEY_APDATA);
  if (apDataToken) {
    return { sourceSystem: SOURCE_GA, token: apDataToken };
  }

  const forBeeToken = getSession(URL_PARAM_KEY_4BEE);
  if (forBeeToken) {
    return { sourceSystem: SOURCE_4BEE, token: forBeeToken };
  }

  return {};
}
